import { ACHIEVEMENTS } from '../content/achievements';
import type { Store } from './Store';

/**
 * Watches the store and unlocks condition-based achievements.
 * Returns an unsubscribe function.
 */
export function trackAchievements(store: Store): () => void {
  let checking = false;
  const check = (): void => {
    if (checking) return;
    checking = true;
    try {
      for (const a of ACHIEVEMENTS) {
        if (a.check && !store.state.achievements.includes(a.id) && a.check(store.state)) store.unlock(a.id);
      }
    } finally {
      checking = false;
    }
  };
  check();
  return store.bus.on('change', check);
}
